"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "rapolano-terme": {
    "2d3e4031": [{
      "hkey": "fa650b14",
      "slug": "rapolano-terme",
      "name": "Rapolano Terme",
      "primary": true,
      "skipSearch": false
    }],
    "modanella": [{
      "hkey": "fa650b14",
      "slug": "rapolano-terme",
      "name": "Rapolano Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "901ca58e": [{
      "hkey": "fa650b14",
      "slug": "rapolano-terme",
      "name": "Rapolano Terme",
      "primary": true,
      "skipSearch": false
    }],
    "poggio-santa-cecilia": [{
      "hkey": "fa650b14",
      "slug": "rapolano-terme",
      "name": "Rapolano Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b1453816": [{
      "hkey": "fa650b14",
      "slug": "rapolano-terme",
      "name": "Rapolano Terme",
      "primary": true,
      "skipSearch": false
    }],
    "san-gimignanello": [{
      "hkey": "fa650b14",
      "slug": "rapolano-terme",
      "name": "Rapolano Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;